import { AbstractHttp, ServiceMethod } from '@app/libs/services';

class AdministrativeService extends AbstractHttp {
  protected services = {
    provinces: {
      uri: 'provinces',
      method: 'GET' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
    },
    wards: {
      uri: 'provinces/{code}/wards',
      method: 'GET' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        code: { required: true },
      },
    },
    allWards: {
      uri: 'wards',
      method: 'GET' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
    },
    transform: {
      uri: 'address',
      method: 'POST' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        address: { required: true },
      },
    },
  };

  getProvinces() {
    return this.send('provinces', {});
  }

  getWards(code: string) {
    return this.send('wards', { params: { code } });
  }

  async getAllAdministrativeUnits() {
    let provinces: any[] = [];
    if (localStorage.getItem('allProvinces')) {
      provinces = JSON.parse(localStorage.getItem('allProvinces') || '[]');
    }
    let allWards: any[] = [];
    if (localStorage.getItem('allWards')) {
      allWards = JSON.parse(localStorage.getItem('allWards') || '[]');
    }

    if (allWards.length === 0 || provinces.length === 0) {
      const { data, errors } = await this.send('allWards', {});

      if (errors) {
        return { provinces: [], wards: {} };
      }

      provinces = data.provinces;
      allWards = data.wards;
      localStorage.setItem('allProvinces', JSON.stringify(provinces || []));
      localStorage.setItem('allWards', JSON.stringify(allWards || []));
    }

    return {
      provinces,
      wards: allWards.reduce(
        (acc, ward) => {
          acc[ward.provinceCode] = [...(acc[ward.provinceCode] || []), ward];
          return acc;
        },
        {} as { [key: string]: any[] }
      ),
    };
  }

  transform(address: string) {
    return this.send('transform', { params: { address } });
  }
}

export const administrativeService = new AdministrativeService();
